import {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";
import type {GetListResponse, GetResponse, ParamsOptions} from "@/src/modules/core/types";

import type {UpdatePlaceholderRequest, UpdatePlaceholderResult} from "../../households/types";
import {
  CreateUserRequest,
  Role,
  UpdateUserRequest,
  UpdateUserStatus,
  User,
  UserCreateFormMetadata,
} from "../types";

class UsersApi extends CoreApi {
  getRoles(): Promise<AxiosResponse<{roles: Role[]}>> {
    return this.get("role");
  }

  getUsers(options: ParamsOptions): Promise<AxiosResponse<GetListResponse<User>>> {
    return this.search("user", options);
  }

  getUser(id: number): Promise<AxiosResponse<Omit<GetResponse<User>, "meta">>> {
    return this.getById("user", String(id));
  }

  createUser(data: CreateUserRequest): Promise<AxiosResponse<Omit<GetResponse<User>, "meta">>> {
    return this.create("user", data);
  }

  updateUser(
    id: number,
    data: UpdateUserRequest | UpdateUserStatus,
  ): Promise<AxiosResponse<Omit<GetResponse<User>, "meta">>> {
    return this.update("user", id, data);
  }

  deleteUser(id: number): Promise<AxiosResponse<Omit<GetResponse<User>, "meta">>> {
    return this.delete("user", id);
  }

  changePassword(data: {password: string}): Promise<AxiosResponse<void>> {
    return this.post("users/change-password", data);
  }

  sendAuthToken(id: number): Promise<AxiosResponse<void>> {
    return this.post("users/send-auth-token", {user_id: id});
  }

  updatePlaceholder(
    userId: number,
    data: UpdatePlaceholderRequest,
  ): Promise<AxiosResponse<{data: UpdatePlaceholderResult}>> {
    return this.post(`users/update-placeholder/${userId}`, data);
  }

  getUserCreate(): Promise<AxiosResponse<{data: UserCreateFormMetadata}>> {
    return this.get("user/create");
  }
}

export const usersApi = new UsersApi();
